/**
 * Indian numbering: `₹12,50,000` (lakh grouping), not `₹1,250,000`.
 * Kollez rule: always Indian format on data screens; never a bare number.
 */
const inrFormatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
});
export function formatINR(amount) {
    if (amount == null || Number.isNaN(amount))
        return '—';
    return inrFormatter.format(amount);
}
/**
 * `formatLPA(650000)` → `₹6.5 LPA`. Kollez shows CTC in LPA on cards and hero fields.
 */
export function formatLPA(amountInRupees) {
    if (amountInRupees == null || Number.isNaN(amountInRupees))
        return '—';
    const lpa = amountInRupees / 100000;
    const rounded = Math.round(lpa * 10) / 10;
    const display = Number.isInteger(rounded) ? rounded.toFixed(0) : rounded.toFixed(1);
    return `₹${display} LPA`;
}
/**
 * Compact for chart labels: `12.5 L`, `1.2 Cr`. No currency symbol; caller adds context.
 */
export function formatCompactINR(amount) {
    if (amount == null || Number.isNaN(amount))
        return '—';
    if (amount >= 1_00_00_000) {
        return `${(amount / 1_00_00_000).toFixed(amount % 1_00_00_000 === 0 ? 0 : 1)} Cr`;
    }
    if (amount >= 1_00_000) {
        return `${(amount / 1_00_000).toFixed(amount % 1_00_000 === 0 ? 0 : 1)} L`;
    }
    if (amount >= 1_000) {
        return `${(amount / 1_000).toFixed(amount % 1_000 === 0 ? 0 : 1)} K`;
    }
    return amount.toString();
}
//# sourceMappingURL=inr.js.map